export const LOAD_GAMES_SUCCESS = 'LOAD_GAMES_SUCCESS';
export const LOAD_SINGLEGAME_SUCCESS = 'LOAD_SINGLEGAME_SUCCESS';
export const LOAD_SEARCH_RESULTS_SUCCESS = 'LOAD_SEARCH_RESULTS_SUCCESS';
export const LOAD_KEYWORD_GAMES_SUCCESS = 'LOAD_KEYWORD_GAMES_SUCCESS';

export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_ERROR = 'SIGNIN_ERROR';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';

export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';

export const ERROR_MESSAGE = 'ERROR_MESSAGE';

export const ADD_LIST_SUCCESS = 'ADD_LIST_SUCCESS';
export const ADD_LIST_ERROR = 'ADD_LIST_ERROR';

export const REMOVE_LIST_SUCCESS = 'REMOVE_LIST_SUCCESS';
export const REMOVE_LIST_ERROR = 'REMOVE_LIST_ERROR';

export const GET_PLAYSTATUS_SUCCESS = 'GET_PLAYSTATUS_SUCCESS';

export const RESET_STATE = 'RESET_STATE';

export const ADD_COMMENTS_SUCCESS = 'ADD_COMMENTS_SUCCESS';
export const ADD_COMMENTS_ERROR = 'ADD_COMMENTS_ERROR';

export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const GET_COMMENTS_ERROR = 'GET_COMMENTS_ERROR';